// ------------------------------------
// Constants
// ------------------------------------
export const MENU_TOGGLE = 'MENU_TOGGLE'

// ------------------------------------
// Actions
// ------------------------------------
export function toggle (value = true) {
  return {
    type    : MENU_TOGGLE,
    payload : value
  }
}

export const actions = { toggle }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MENU_TOGGLE] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = false
export default function siteMenuReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/siteMenu.js